import React, { PropsWithChildren } from 'react'

interface VideoViewProps extends PropsWithChildren<any> {
  src: string
  poster?: string
  play: boolean
  className?: string
  style?: any
  didLoad: () => void
  didFail: () => void
}

interface ImageViewState {
  done: boolean
}

interface VideoRef {
  readonly current: HTMLVideoElement | null
}

export default class VideoView extends React.Component<VideoViewProps, ImageViewState> {
  videoRef: VideoRef

  constructor(props: VideoViewProps) {
    super(props)

    this.state = {
      done: false
    }

    this.videoRef = React.createRef()
  }

  componentDidUpdate(prevProps: VideoViewProps, _prevState: any) {
    if (this.props.className !== prevProps.className) {
      this.setState({ done: false }, () => {
        if (this.videoRef.current !== null && this.videoRef.current.readyState >= 3) {
          this.handleLoad()
        }
      })
    }
    if (this.props.loop !== prevProps.loop && this.videoRef.current) {
      if (this.props.loop) {
        this.videoRef.current.play()
      } else {
        this.videoRef.current.pause()
        this.videoRef.current.currentTime = 0
      }
    }
  }

  handleLoad() {
    if (this.state.done) {
      return
    }

    this.setState({ done: true }, this.props.didLoad)
  }

  handleFail() {
    if (this.state.done) {
      return
    }

    this.setState({ done: true }, this.props.didFail)
  }

  render() {
    return (
      <video
        ref={this.videoRef}
        loop
        muted
        autoPlay
        playsInline
        src={this.props.src}
        poster={this.props.poster}
        onCanPlayThrough={() => this.handleLoad()}
        onError={() => this.handleFail()}
        className={this.props.className}
        style={this.props.style}
      />
    )
  }
}